import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, Redirect, withRouter} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import YCComponent from "./yc-component";
import {setTheme} from "../actions/theme-actions";
import assets from "../assets";

class InitScreen extends YCComponent {

    componentDidMount() {
        this.props.setTheme('landing');
    }

    componentWillUnmount() {
        this.props.setTheme();
    }

    render() {
        let { from } = this.props.location.state || { from: { pathname: '/dashboard' } };

        if (this.props.auth.authenticating) {
            return (
                <div>
                    <div className='text-center'>
                        <p>Loading</p>
                        <p><FontAwesomeIcon icon={['far', 'spinner']} spin/></p>
                    </div>
                </div>
            );
        }

        if (this.props.auth.isAuthenticated) {
            return (
                <Redirect to={from}/>
            );
        }

        return (
            <div className='container' id='init-screen'>
                <div className='row aligned-lg separate-bottom-grid'>
                    <div className='col-lg-4'>
                        <div className='card aligned-card'>
                            <div className='card-body'>
                                <h1 className='display-2'>Dokážeš uřídit rodinný rozpočet?</h1>
                                <p>Zapoj se do největší české soutěže. Srovnej své síly v týmovém souboji.  <br/>Ať nejlepší vyhraje.</p>
                                <p>Podívej se na <Link to='/pravidla'>pravidla soutěže</Link>.</p>
                                <div className='fill'/>
                                <div>
                                    <a href='/zapoj-se#1' className='btn btn-pink'>Soutěž s námi</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='card aligned-card'>
                            <div className='card-body'>
                                <h1 className='display-2'>Soutěž Rozpočti si to! 1st</h1>
                                <p>Zapoj se do velké české soutěže pro 1. stupeň ZŠ. Rozviň svou kreativitu v týmovém souboji a nasbírej co nejvíce chechtáků.</p>
                                <p>Podívej se na <Link to='/pravidla'>pravidla soutěže</Link>.</p>
                                <div className='fill'/>
                                <div>
                                    <a href='/zapoj-se#2' className='btn btn-pink'>Soutěž s námi</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='card aligned-card'>
                            <div className='card-body'>
                                <h1 className='display-2'>Máš na to postarat se o svou rodinu?</h1>
                                <p>Tajemství ke spokojenému životu nespočívá ve výši výplaty, ale v tom, jak s ní naložíš. Vyzkoušej si, jak na tom jsi s finanční gramotností v naší interaktivní hře.</p>
                                <div className='fill'/>
                                <div>
                                    <a href='https://minihra.rozpoctisito.eu' className='btn btn-primary'>Hraj minihru</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row' id='about-row'>
                            <div className='col-md-3 col-lg-2 text-center'>
                                <img id='yc-logo' src={assets['pages']['logo_your_chance']} className='img-fluid'/>
                            </div>
                            <div className='col-md-9 col-lg-7'>
                                <span>Od roku 2010 pomáháme dětem stát se finančně gramotnými.<br/>Soutěž Rozpočti si to! je naše vlajková loď.</span>
                            </div>
                            <div className='col-lg-3 text-right'>
                                <a href='/o-projektu' className='btn btn-white-secondary'>O projektu</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setTheme: setTheme
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(InitScreen));
